export default class PlantationLayer {
  /**
   * Represent a physical map layer (i.e.: buildings, herbs, canopea, water,...)
   *
   * @param id {String|null} Unique identifier
   * @param name {String} Layer name
   * @param description {String} Layer description
   * @param borderColor {String} RGB color string
   * @param fillColor {String} RGBA color string
   */
  constructor ({ id = null, name, description, borderColor, fillColor }) {
    this.id = id
    this.name = name
    this.description = description
    this.borderColor = borderColor
    this.fillColor = fillColor
  }
}
